import { Field } from 'formik';
import type { FieldProps } from 'formik';

import { Input } from '@frontend/legacy-components';

import { HorizontalFormControl } from 'components/listTablePage';

import type { OrdersListFiltersFormData } from './types';

export const PriceFilter = () => {
  return (
    <HorizontalFormControl label="Price">
      <Field name="totalPrice">
        {({
          field,
          form,
        }: FieldProps<
          OrdersListFiltersFormData['totalPrice'],
          OrdersListFiltersFormData
        >) => (
          <Input
            value={field.value}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              const value = e.target.value;
              if (/^[\d]*(\.[\d]*)?$/.test(value)) {
                form.setFieldValue(field.name, value);
              }
            }}
          />
        )}
      </Field>
    </HorizontalFormControl>
  );
};
